import { useEffect } from "react";
import { PublicShell } from "../components/PublicShell";
import Locator from "./Locator";

export default function PublicFindSupport() {
  useEffect(() => {
    document.title = "Find Recovery Support Near You — UK & Ireland | TaperPath";
    let el = document.querySelector('meta[name="description"]');
    if (!el) { el = document.createElement("meta"); el.setAttribute("name", "description"); document.head.appendChild(el); }
    el.setAttribute("content", "Search recovery and drug & alcohol support services across the UK & Ireland by postcode or town. Includes live CQC-verified services in England.");
    return () => { document.title = "TaperPath"; };
  }, []);
  return (
    <PublicShell>
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
        <Locator />
      </div>
    </PublicShell>
  );
}
